<template lang="pug">
.-answers-analytics__table
  ul.table__row.-answers-analytics__table-row(
    @click="toggleOpen"
  )

    li.table__col.-answers-analytics__table-col
      Avatar(:img="validator.info.avatar" circle size="s")
      div.justify-center.flex.flex-col.align-star.margin-left__10(
        style="width: calc(100% - 50px)"
      )
        p.table__text.table__text-withAvatar.pointer.-answers-analytics__name
          |{{validator.info.name}} {{validator.info.lastname}}
        p.table__text.table__text-withAvatar.grey-color.-answers-analytics__email
          |{{validator.info.email}}

    li.table__col.-answers-analytics__table-col
      .-answers-analytics__info(
        :class="isOpen && '-answers-analytics__info-open'"
      )
        p.table__text.-overflow-.-answers-analytics__title
          | Проверено работ
        p.table__text.-overflow-.-answers-analytics__text
          | {{validator.count}}

    li.table__col.-answers-analytics__table-col(
      v-for="item in tariffsData"
      :key="item.id + 'tarrifs'+ validator.user"
    )
      .-answers-analytics__info(v-if="item.count > 0")
        p.table__text.-overflow-.-answers-analytics__title
          | {{item.name}}
        p.table__text.-overflow-.-answers-analytics__text
          | {{item.count}}

    li.table__col.-answers-analytics__table-col
      Icon.select__icon.form-item__icon(
        icon="arrow-down-thick"
        :class="{'-opened-': isOpen}"
      )
  SlideUpDown(
    :duration="slideDuration"
    :active="isOpen"
  )
    TableUser(
      :data="usersData"
      :tariffs="tariffsData"
    )


</template>
<script>
import { mapState } from 'vuex';
import SlideUpDown from 'vue-slide-up-down';
import TableUser from './components/TableUser';

export default {
  components: { TableUser, SlideUpDown },
  props: ['validator'],
  data() {
    return {
      isOpen: false,
      slideDuration: 200,
      usersData: [],
      tariffsData: []
    };
  },
  computed: {
    ...mapState('answersAnalyticsValidators', {
      validatorsList: s => s.data.validatorsList,
      users: s => s.data.users,
      tariffs: s => s.data.tariffs
    }),
    count() {
      const count = 3;
      return count - this.validator.isSpeed.length;
    }
  },
  watch: {
    validatorsList() {
      this.setData();
    },
    users() {
      this.setData();
    },
    tariffs() {
      this.setData();
    }
  },
  mounted() {
    this.setData();
  },
  methods: {
    setData() {
      if (this.usersData.length === 0) {
        this.usersData = this.validator.analyticsCourseData.map(el => ({
          ...el,
          ...this.users.find(elem => elem.authUserId === el.authUserId)
        }));
      }

      if (this.tariffsData.length === 0) {
        this.tariffsData = this.tariffs.map(el => ({
          ...el,
          count: this.usersData.filter(elem => elem.tariffId === el.id).length
        }));
      }
    },
    toggleOpen() {
      this.isOpen = !this.isOpen;
    }
  }
};
</script>
